/**
 * TaxIDMask component module.
 * @module shared/components/TaxIDMask
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

const _NumberMask = styled.span`
  &:hover {
    ${props => props.readOnly ? 'cursor: default;' : 'cursor: pointer;'}
  }
`;

const TaxIDMask = props => {
  const {taxID, clientTaxID} = props;
  const [masked, setMasked] = React.useState(1);
  const [maskedNumber, setMaskedNumber] = React.useState('');

  React.useEffect(() => {
    if (!masked) {
      return setMaskedNumber(taxID || clientTaxID);
    }
    if (!(taxID || clientTaxID)) {
      return setMaskedNumber('-');
    }

    return setMaskedNumber('xxxx' + (clientTaxID || taxID).substr(-4, 4));
  }, [taxID, clientTaxID, masked]);

  return <_NumberMask
    className={props.className}
    readOnly={props.readOnly}
    onClick={e => {
      e.stopPropagation();
      setMasked(current => !current);
    }}>{maskedNumber || '-'}</_NumberMask>;
};

export default TaxIDMask;

TaxIDMask.propTypes = {
  /**
   * A Tax ID
   */
  taxID: PropTypes.string.isRequired,
  /**
   * Client's Tax ID, displays instead of tax id if passed
   */
  clientTaxID: PropTypes.string.isRequired,
  /**
   * Whether TaxIDMask is read-only
   */
  readOnly: PropTypes.bool,
  className: PropTypes.string,
};
